import { ApiFormType } from "@/types/forms/form.types.ts";
import { usePerformanceReviewReviewerResults } from "@/queries/performance-reviews/use-performance-reviews.query.ts";
import { Button, ButtonLink, Modal, ModalProps, Stack, useModals } from "@skailer-com/uikit";
import { useTranslation } from "react-i18next";
import { FormResultForEmployeeModalContent } from "@/components/form-result/result-modal/components/FormResultForEmployeeModalContent.tsx";

interface Props extends ModalProps {
  reviewerTypeId: number;
  respondentUuid: string;
  performanceReviewId?: number;
  employeeId?: number;
  onEditAnswers?: () => void;
}

export function FormResultForReviewerModal({
  reviewerTypeId,
  respondentUuid,
  performanceReviewId,
  employeeId,
  onEditAnswers,
  ...props
}: Props) {
  const { t } = useTranslation();
  const { close } = useModals();
  const { data: reviewerResults } = usePerformanceReviewReviewerResults({
    reviewerTypeId,
    respondentUuid,
    enabled: !!reviewerTypeId && !!respondentUuid,
  });

  const canViewFullReview =
    !!reviewerResults?.acl?.can_view &&
    performanceReviewId !== undefined &&
    employeeId !== undefined;

  return (
    <Modal
      {...props}
      layout={"stretch"}
      size={"lg"}
      variant={"side"}
      title={t("common:view_responses")}
      withCloser
      closeByEscEnabled
      actions={
        canViewFullReview || onEditAnswers ? (
          <Stack className={"pt-(--gap-md) print:hidden"} gap={"md"}>
            {onEditAnswers && (
              <Button
                size={"lg"}
                variant={"primary"}
                onClick={() => {
                  close(props.id);
                  onEditAnswers();
                }}
              >
                {t("scorecards:change_answers")}
              </Button>
            )}
            {canViewFullReview && (
              <ButtonLink
                size={"lg"}
                variant={"secondary"}
                href={`/performance-reviews/${performanceReviewId}/view/participants/${employeeId}`}
                target={"_blank"}
              >
                {t("common:open_results")}
              </ButtonLink>
            )}
          </Stack>
        ) : undefined
      }
    >
      <FormResultForEmployeeModalContent
        questionnaireId={reviewerTypeId}
        employeeId={employeeId}
        respondentUuid={respondentUuid}
        type={ApiFormType.performanceReview}
      />
    </Modal>
  );
}
